import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/navigation';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-3">
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900">
              网址导航分类
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              覆盖九大核心分类，百万网址任你浏览
            </p>
          </div>
          <Link
            to="/category/yingshi"
            className="text-sm text-primary-500 hover:text-primary-600 font-label font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {navCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative h-56 rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${cat.color}`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label font-medium">
                {cat.count}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-lg bg-background-50/20 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm text-background-50`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-background-50">{cat.name}</h3>
                </div>
                <p className="text-background-200 text-xs">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}